// * Search the DOM (and memoize) for elements by ID.
export const getElementById = (id) => {
  try {
    // * Throw error unless ID is provided.
    if (!id) throw Error('!!! ERROR (DOM.fns.getElementById): Unable to locate element. No ID provided.')

    MK.DOM.elements.byID = MK.DOM.elements.byID || {}

    // * Memoize previously identified elements
    MK.DOM.elements.byID[id] = MK.DOM.elements.byID[id] || document.getElementById(id)

    // * Throw error unless element is found.
    if (!MK.DOM.elements.byID[id]) throw Error(`!!! ERROR (DOM.fns.getElementById): Unable to locate element with ID: ${id}`)

    return MK.DOM.elements.byID[id]
  } catch (error) {
    MK.captureException && MK.captureException(error)
    return null
  }
}
